"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconStyled = void 0;
exports.getSizeInPx = getSizeInPx;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = require("./Icon.consts");

function getSizeInPx(size) {
  switch (size) {
    case 'large':
      return "".concat(_Icon.ICON_LARGE_SIZE);

    case 'medium':
      return "".concat(_Icon.ICON_MEDIUM_SIZE);

    case 'small':
    default:
      return "".concat(_Icon.ICON_SMALL_SIZE);
  }
}

const IconStyled = _styledComponents.default.svg.withConfig({
  displayName: "Iconstyles__IconStyled"
})(["width:", "px;height:", "px;position:relative;flex-shrink:0;fill:currentColor;vertical-align:bottom;"], props => getSizeInPx(props.size), props => getSizeInPx(props.size));

exports.IconStyled = IconStyled;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJnZXRTaXplSW5QeCIsInNpemUiLCJJQ09OX0xBUkdFX1NJWkUiLCJJQ09OX01FRElVTV9TSVpFIiwiSUNPTl9TTUFMTF9TSVpFIiwiSWNvblN0eWxlZCIsInN0eWxlZCIsInN2ZyIsInByb3BzIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvSWNvbi9JY29uLnN0eWxlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ3N0eWxlZC1jb21wb25lbnRzJ1xuaW1wb3J0IHsgSUNPTl9MQVJHRV9TSVpFLCBJQ09OX01FRElVTV9TSVpFLCBJQ09OX1NNQUxMX1NJWkUgfSBmcm9tICcuL0ljb24uY29uc3RzJ1xuaW1wb3J0IHsgSWNvblNpemUgfSBmcm9tICcuL0ljb24udHlwZXMnXG5cbmV4cG9ydCBmdW5jdGlvbiBnZXRTaXplSW5QeChzaXplPzogSWNvblNpemUpIHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnbGFyZ2UnOlxuICAgICAgcmV0dXJuIGAke0lDT05fTEFSR0VfU0laRX1gXG4gICAgY2FzZSAnbWVkaXVtJzpcbiAgICAgIHJldHVybiBgJHtJQ09OX01FRElVTV9TSVpFfWBcbiAgICBjYXNlICdzbWFsbCc6XG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBgJHtJQ09OX1NNQUxMX1NJWkV9YFxuICB9XG59XG5cbmV4cG9ydCBjb25zdCBJY29uU3R5bGVkID0gc3R5bGVkLnN2Zzx7IHNpemU/OiBJY29uU2l6ZSB9PmBcbiAgd2lkdGg6ICR7cHJvcHMgPT4gZ2V0U2l6ZUluUHgocHJvcHMuc2l6ZSl9cHg7XG4gIGhlaWdodDogJHtwcm9wcyA9PiBnZXRTaXplSW5QeChwcm9wcy5zaXplKX1weDtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBmbGV4LXNocmluazogMDtcbiAgZmlsbDogY3VycmVudENvbG9yO1xuICB2ZXJ0aWNhbC1hbGlnbjogYm90dG9tO1xuYFxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBR08sU0FBU0EsV0FBVCxDQUFxQkMsSUFBckIsRUFBc0M7RUFDM0MsUUFBUUEsSUFBUjtJQUNFLEtBQUssT0FBTDtNQUNFLGlCQUFVQyxxQkFBVjs7SUFDRixLQUFLLFFBQUw7TUFDRSxpQkFBVUMsc0JBQVY7O0lBQ0YsS0FBSyxPQUFMO0lBQ0E7TUFDRSxpQkFBVUMscUJBQVY7RUFQSjtBQVNEOztBQUVNLE1BQU1DLFVBQVUsR0FBR0MseUJBQUEsQ0FBT0MsR0FBVjtFQUFBO0FBQUEsNEdBQ1pDLEtBQUssSUFBSVIsV0FBVyxDQUFDUSxLQUFLLENBQUNQLElBQVAsQ0FEUixFQUVYTyxLQUFLLElBQUlSLFdBQVcsQ0FBQ1EsS0FBSyxDQUFDUCxJQUFQLENBRlQsQ0FBaEIifQ==